import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/Common";
import { History, LogIn, Plus, Pencil, Trash2, ArrowRightLeft, Power, Flame } from "lucide-react";

const ACTION_META = {
  login: { icon: LogIn, cls: "text-blue-400 bg-blue-400/15" },
  create: { icon: Plus, cls: "text-primary bg-primary/15" },
  update: { icon: Pencil, cls: "text-gold bg-gold/15" },
  delete: { icon: Trash2, cls: "text-destructive bg-destructive/15" },
  transfer: { icon: ArrowRightLeft, cls: "text-blue-400 bg-blue-400/15" },
  toggle: { icon: Power, cls: "text-muted-foreground bg-secondary" },
  interested: { icon: Flame, cls: "text-gold bg-gold/15" },
  not_interested: { icon: Flame, cls: "text-muted-foreground bg-secondary" },
  followup: { icon: Flame, cls: "text-gold bg-gold/15" },
};

export default function Audit() {
  const [logs, setLogs] = useState([]);
  const [entity, setEntity] = useState("");

  const load = () => api.get("/audit", { params: entity ? { entity_type: entity } : {} }).then((r) => setLogs(r.data));
  useEffect(() => { load(); }, [entity]);

  const entities = ["", "auth", "branch", "admin", "manager", "client", "holding", "product", "opportunity"];

  return (
    <div className="animate-fade-up">
      <PageHeader title="Audit History" subtitle="Complete organization-wide activity trail" />
      <div className="flex gap-1.5 mb-4 flex-wrap">
        {entities.map((e) => (
          <button key={e || "all"} onClick={() => setEntity(e)} data-testid={`audit-filter-${e || "all"}`}
            className={`px-3 py-1.5 rounded-full text-xs font-medium capitalize row-hover ${entity === e ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground hover:text-foreground"}`}>
            {e || "All"}
          </button>
        ))}
      </div>
      <div className="card-surface rounded-xl overflow-hidden" data-testid="audit-list">
        {logs.length === 0 && <div className="py-16 text-center text-muted-foreground"><History className="h-8 w-8 mx-auto mb-2 opacity-40" />No audit records.</div>}
        {logs.map((l) => {
          const m = ACTION_META[l.action] || { icon: History, cls: "text-muted-foreground bg-secondary" };
          const Icon = m.icon;
          return (
            <div key={l.id} className="flex items-center gap-4 px-5 py-3 border-b border-border/40 last:border-0" data-testid={`audit-${l.id}`}>
              <div className={`h-9 w-9 rounded-full flex items-center justify-center shrink-0 ${m.cls}`}><Icon className="h-4 w-4" /></div>
              <div className="flex-1 min-w-0">
                <div className="text-sm">{l.detail}</div>
                <div className="text-xs text-muted-foreground">
                  <span className="capitalize">{l.action}</span> · {l.entity_type} · by {l.user_name} <span className="capitalize">({(l.role || "").replace("_", " ")})</span>
                </div>
              </div>
              <div className="text-xs text-muted-foreground num text-right shrink-0">
                {new Date(l.ts).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
